import { render, staticRenderFns } from "./hokl_overview.vue?vue&type=template&id=f8f12dec&scoped=true"
import script from "./hokl_overview.vue?vue&type=script&lang=js"
export * from "./hokl_overview.vue?vue&type=script&lang=js"
import style0 from "./hokl_overview.vue?vue&type=style&index=0&id=f8f12dec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f12dec",
  null
  
)

export default component.exports